import React, { Component } from 'react'
import { translate } from "react-i18next";
import ReadAxios from '../axiosComponent/read';
import UpdateAxios from '../axiosComponent/update';
import { isEmpty } from 'lodash';
import { Form as FormUi, Container, Dropdown, Grid, Checkbox, Radio, Table } from "semantic-ui-react";

class UserAlerts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userInfo: [],
            getAlerts: [],
            sms: false,
            email: false,
            subcribedAlerts: [
                { "name":(props.t("alerts.allocation_acceptance_alert") || "Allocation acceptance alert"), "alertTypeCode": "ALT-01-01", "smsFlag": "0", "emailFlag": "0" },
                { "name":(props.t("alerts.allocation_rejection_alert") || "Allocation rejection alert"), "alertTypeCode": "ALT-01-02", "smsFlag": "0", "emailFlag": "0" },
                { "name":(props.t("alerts.container_drop_alert") || "Container drop alert"), "alertTypeCode": "ALT-01-03", "smsFlag": "0", "emailFlag": "0" },
                { "name":(props.t("alerts.notes_alert") || "Notes alert"), "alertTypeCode": "ALT-01-04", "smsFlag": "0", "emailFlag": "0" },
                { "name":(props.t("alerts.bid_response_alert") || "Bid response alert"), "alertTypeCode": "ALT-01-05", "smsFlag": "0", "emailFlag": "0" },
                { "name":(props.t("alerts.vehicle_reporting_alert") || "Vehicle Reporting alert"), "alertTypeCode": "ALT-01-06", "smsFlag": "0", "emailFlag": "0" },
            ],
            permissions: '',
        };
    }

    componentDidMount() {
        setTimeout(async() => {
            if(this.props.userInfo.u_id){
                this.getUserDetails(this.props.userInfo.u_id)
              }
        }, 700);
    }

    getUserDetails = (userId)=>{
        ReadAxios({ url: `userMaster/${userId}` })
          .then((dataArray) => {
            let userDetails = dataArray?.data?.resultSet? dataArray?.data?.resultSet[0] : null
            this.setState({
                email: userDetails?.emailFlag == 1 ? true : false,
                sms: userDetails?.smsFlag == 1 ? true : false,
            })
          })
          .catch((err) => {
            console.log(err);
          });
      }

    toggle = (e, data) => {
        console.log(data);
        var checkingSmsT = data.checked;
        var checkingEmailT = data.checked;
        let code = data.name.split(',');
        // for (var j = 0; j < this.state.subcribedAlerts.length; j++) { 
        //     if (code[0] === this.state.subcribedAlerts[j].alertTypeCode) {
        //         let temp = [...this.state.subcribedAlerts];
        //         temp[j].smsFlag = data.checked ? "1" : "0" ;
        //         temp[j].emailFlag = data.checked ? "1" : "0";
        //         this.setState({
        //             subcribedAlerts: temp,
        //         });
        //     }
        // }
        if (code[1] == "email") { 
            for (var j = 0; j < this.state.subcribedAlerts.length; j++) { 
                if (code[0] === this.state.subcribedAlerts[j].alertTypeCode) {
                    let temp = [...this.state.subcribedAlerts];
                    temp[j].emailFlag = data.checked ? "1" : "0";
                    this.setState({
                        subcribedAlerts: temp,
                    });
                }
            }
            UpdateAxios({ url: `alertSetting/createAlertSetting`, 
        payload: { emailFlag: checkingEmailT ? "1" : "0" ,smsFlag: data.smsValue , alertCode: code[0], name: data.name}, 
        uniqueId: this.props.userInfo.u_id })
        .then((res) => {
            //this.getMasterData(this.props.userInfo.u_id)
            if (res.status === 200) {
                this.props.setFieldValue("emailFlag",checkingEmailT ? "1" : "0")
              //  this.getMasterData(this.props.userInfo.u_id)
                if (res.data.status === 204) {
                    // this.getMasterData(this.props.userInfo.u_id)
                }
            }
        })
        .catch((err) => {
            console.log(err);
            //this.getMasterData(this.props.userInfo.u_id)
            this.setState({ loadingData: false, rowData: [] });
        });
        }
        else if (code[1] == "sms") { 
            for (var j = 0; j < this.state.subcribedAlerts.length; j++) { 
                if (code[0] === this.state.subcribedAlerts[j].alertTypeCode) {
                    let temp = [...this.state.subcribedAlerts];
                    temp[j].smsFlag = data.checked ? "1" : "0";
                    this.setState({
                        subcribedAlerts: temp,
                    });
                }
            }
            UpdateAxios({ url: `alertSetting/createAlertSetting`, 
        payload: { smsFlag: checkingSmsT ? "1" : "0",emailFlag:data.emailValue, alertCode: code[0], name: data.name}, 
        uniqueId: this.props.userInfo.u_id })
        .then((res) => {
            //this.getMasterData(this.props.userInfo.u_id)
            if (res.status === 200) {
                this.props.setFieldValue("smsFlag",checkingSmsT ? "1" : "0")
                //this.getMasterData(this.props.userInfo.u_id)
                if (res.data.status === 204) {
                    // this.getMasterData(this.props.userInfo.u_id)
                }
            }
        })
        .catch((err) => {
            console.log(err);
            //this.getMasterData(this.props.userInfo.u_id)
            this.setState({ loadingData: false, rowData: [] });
        });
        }
        
    }

    recieveAlerts = (e, data) => {
        var checkingSms = data.checked;
        var checkingEmail = data.checked;
        if (data.name === 'userSms') {
            this.setState({
                sms: data.checked,
            })
            UpdateAxios({ url: `alertSetting/setGlobalSettings`, payload: { smsFlag: checkingSms ? '1' : '0' }, uniqueId: this.props.userInfo.u_id })
                .then((res) => {
                    if (res.status === 200) {
                        this.props.setFieldValue("smsFlag",checkingSms)
                        //this.getMasterData(this.props.userInfo.u_id)
                        if (res.data.status === 204) {
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.setState({ loadingData: false, rowData: [] });
                });
        }

        if (data.name === 'userEmail') {
            this.setState({
                email: data.checked,
            })
            UpdateAxios({ url: `alertSetting/setGlobalSettings`, payload: { emailFlag: checkingEmail ? '1' : '0' }, uniqueId: this.props.userInfo.u_id })
                .then((res) => {
                    if (res.status === 200) {
                        this.props.setFieldValue("emailFlag",checkingEmail)
                        //this.getMasterData(this.props.userInfo.u_id)
                        if (res.data.status === 204) {
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.setState({ loadingData: false, rowData: [] });
                });
        }
    }

    // getMasterData = (uid) => {
    //     console.log('first call')
    //     ReadAxios({ url: `alertSetting/getAlertSettingByUser/${uid}`, payload:{u_id: uid} })
    //         .then((response) => {
    //             if (response.status === 200 && response.data.resultSet !== "") {
    //                 let resultSet = response.data.resultSet;
    //                 this.setState({
    //                     getAlerts: resultSet,
    //                     loaded: true
    //                 })
    //                 if (resultSet.length > 0) {
    //                     for (var i = 0; i < this.state.getAlerts.length; i++) { 
    //                         for (var j = 0; j < this.state.subcribedAlerts.length; j++) { 
    //                             if (this.state.getAlerts[i].alertTypeCode === this.state.subcribedAlerts[j].alertTypeCode) {
    //                                 let temp = [...this.state.subcribedAlerts];
    //                                 temp[j].smsFlag = this.state.getAlerts[i].smsFlag;
    //                                 temp[j].emailFlag = this.state.getAlerts[i].emailFlag;
    //                                 this.setState({
    //                                     subcribedAlerts: temp,
    //                                 });
    //                             }
    //                         }
    //                     }
                        
    //                 } else {
    //                     resultSet = this.state.subcribedAlerts
    //                     this.setState({
    //                         subcribedAlerts: resultSet,
    //                     })
    //                 }

    //                 if (response.data.status === 204) {
    //                     // alert(response.data.message)
    //                 }

    //             }
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //             this.setState({ loadingData: false, rowData: [] });
    //         });
    // }

    render() {
        const { userInfo, email, sms, subcribedAlerts } = this.state
        const { t } = this.props
        console.log(subcribedAlerts);
        return (
            <React.Fragment>

                <div className="container-fluid animated slideInDown pad w3-white">
                    <div className="m-3 pl-3">
                        <div className="ui form">
                            <Grid className="p-2 ml-2 w3-small" columns="7">
                                <Grid.Row>
                                    <Grid.Column>
                                        <label className="labelName">{t("recieve_sms") || "Recieve SMS"}</label>
                                    </Grid.Column>
                                    <Grid.Column width="3">
                                        <Radio toggle name="userSms"
                                            checked={sms}
                                            onChange={this.recieveAlerts}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <label className="labelName">{t("recieve_email") || "Recieve Email"}</label>
                                    </Grid.Column>
                                    <Grid.Column width="3">
                                        <Radio toggle name="userEmail"
                                            checked={email}
                                            onChange={this.recieveAlerts}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </div>
                    </div>
                </div>

                <div className="container-fluid animated slideInDown pad w3-white">
                    <div className="m-3 pl-3">
                        <div className="ui form">
                            <Grid>
                                <Grid.Row columns="2" className=" ml-2 w3-small">
                                    <Grid.Column>
                                        <label className="font-weight-bold mt-1">{t("alert") || "Alerts"}</label>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <Table className="w3-table-all w3-bordered w3-round fontertb w3-white w3-small">
                                <Table.Header>
                                    <Table.Row className="w3-light-grey">
                                        <Table.HeaderCell>{t("type") || "Type"}</Table.HeaderCell>
                                        <Table.HeaderCell>{t("email") || "Email"}</Table.HeaderCell>
                                        <Table.HeaderCell>{t("sms") || "SMS"}</Table.HeaderCell>
                                        {/* <th>Whatsapp</th> */}
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {subcribedAlerts.map((object, index) => (
                                        <>
                                        {console.log(+object.emailFlag === 1 ? 'ok' : 'wrong')}
                                        <Table.Row>
                                        <Table.Cell><label className="labelName">{object.name}</label></Table.Cell>
                                        <Table.Cell><Checkbox
                                            name={object.alertTypeCode + ",email"}
                                            smsValue={object.smsFlag}
                                            onChange={this.toggle}
                                            checked={object.emailFlag.toString() == "1" ? true : false}
                                        /></Table.Cell>
                                        <Table.Cell><Checkbox
                                            name={object.alertTypeCode + ",sms"}
                                            emailValue={object.emailFlag}
                                            onChange={this.toggle}
                                            checked={object.smsFlag.toString() == "1" ? true : false}
                                        /></Table.Cell>
                                        </Table.Row>
                                        </>
                                    ))} 
                                </Table.Body>
                            </Table>
                        </div>
                    </div></div>
            </React.Fragment>

        )
    }
}

export default translate("alert")(UserAlerts);